import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-wizard-base-component',
  template: '',
})
export class ModalWizardStepContentBaseComponent {
  title: string = '';
}
